<template>
    <div>
        <card-header title='New Course' icon="fa-plus"/>

        <card-body>
            <course-form :course="course" :card="card"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!course.title"
                    ><i class="fas fa-plus mr-2"></i>New Course</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import CourseForm from "@/cards/courses/CourseForm";

    import {client as http} from '../../http_client';

    export default {
        components: {CardHeader, CardToolbar, CardBody, CardFooter, CourseForm},
        props: ['card'],
        data() {
            return {
                course: {}
            }
        },
        methods: {
            submit: function() {
                this.$emit('loading', true);
                http.post('courses/', this.course, {force: true}).then(response => {
                    this.$reloadCard('courses');
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            }
        }
    }
</script>
